export default __webpack_public_path__ + "static/media/dave.54d055b1.jpeg";